import 'es6-promise';
import 'isomorphic-fetch';
import * as _ from 'lodash';
import * as actions from './index';
import { ISearchCriteria } from '../state-helpers/search-criteria'
import { ISort } from '../state-helpers/sorts'
import { ISearchAppState } from '../reducers/index'

const memoizedFetch = (searchTerm: string, trackingId: string, hitId: string, dispatch: any) => {
    var url = '/api/v1/search/trackClick?searchTerm='
    const init: RequestInit = {
        method: 'POST',
        body: JSON.stringify({
            searchTerm: searchTerm,
            trackingId: trackingId,
            hitId: hitId
        }),
        headers: new Headers({ 'Content-Type': 'application/json; charset=utf-8' }),
    };
    return window.fetch(url, init)
    .then(function (response) {
        if (response.status === 504) {
            const errorMsg = new Error("Failed to fetch");
            errorMsg.message = "Failed to fetch";
            throw errorMsg;
        }
        // Catch the bad response
        else if (response.status >= 400) {
            const errorMsg = new Error("Bad response");
            errorMsg.message = "Bad response";
            throw errorMsg;
        }
        return response.json();
    })
    .then(m => console.log(m));
};

export function trackClick(hitId: string) {
    return (dispatch, getState) => {
        let state = getState() as ISearchAppState;
        var searchTerm = state.searchTermModel;
        var trackingId = state.resultsModel.trackingId;
        memoizedFetch(searchTerm, trackingId, hitId, dispatch);
    }
}